<template>
  <div v-loading="loading" class="project-distribution-chart">
    <h3 class="project-distribution-chart__title">Статистика по регистрациям на проекты</h3>
    <div class="project-distribution-chart__table">
      <div class="project-distribution-chart__table-header">
        <div class="project-distribution-chart__table-title">Название</div>
        <div 
          class="project-distribution-chart__table-title-years"
          v-if="projectsDistribution"
        >
          <div
            class="project-distribution-chart__table-title-year"
            v-for="year in projectsDistribution.projectRegistrationYears"
            :key="year.year"
          > {{ year.year }} </div>
        </div>
        <div class="project-distribution-chart__table-title-total">Всего</div>
      </div>
      <div class="project-distribution-chart__table-projects" v-if="projectsDistribution">
        <div
          class="project-distribution-chart__table-project-wrapper"
          v-for="(project, index) in resultProjectsList"
          :key="project.projectId">
          <div class="project-distribution-chart__table-project" @click="toggleNominations(index)">
            <div class="project-distribution-chart__table-project-title">{{ project.name }} 
              <div :class="{ 'rotate-90': expandedProjects[index] }" class="project-distribution-chart__table-project-title-icon"></div>
            </div>
            <div class="project-distribution-chart__table-project-years" >
                <div
                  class="project-distribution-chart__table-project-year"
                  v-for="year in projectsDistribution.projectRegistrationYears"
                  :key="year.year"
                > {{ usersByYear(year.year, project) }} </div>
              </div>
            <div class="project-distribution-chart__table-project-total">{{ prettieredQuantity(project.totalUsers) }}</div>
          </div>
          <div
            class="project-distribution-chart__table-nominations"
            v-for="nomination in project.nominations"
            :key="nomination.nominationId"
            >
              <div v-if="expandedProjects[index]" class="project-distribution-chart__table-nomination">
                <div class="project-distribution-chart__table-nomination-title">{{ nomination.name }}</div>
                <div class="project-distribution-chart__table-nomination-years" >
                  <div
                    class="project-distribution-chart__table-nomination-year"
                    v-for="year in projectsDistribution.projectRegistrationYears"
                    :key="year.year"
                  > {{ nominationUsersByYear(year.year, nomination) }} </div>
                </div>
                <div class="project-distribution-chart__table-nomination-total">{{ prettieredQuantity(nomination.totalUsers) }}</div>
              </div>
          </div>
        </div>
      </div>
      <div class="project-distribution-chart__table-footer">
        <div class="project-distribution-chart__table-footer-title" >Общее количество</div>
        <div 
          class="project-distribution-chart__table-footer-years"
          v-if="projectsDistribution"
        >
          <div
            class="project-distribution-chart__table-footer-year"
            v-for="year in projectsDistribution.projectRegistrationYears"
            :key="year.year"
          > {{ prettieredQuantity(year.totalUsers) }} </div>
        </div>
        <div class="project-distribution-chart__table-title-total">{{ prettieredQuantity(totalUsers) }}</div>
      </div>
    </div>
    <div class="project-distribution-chart__footer">
      <!-- <button
        class="project-distribution-chart__footer-download"
      >
        <div class="project-distribution-chart__footer-download-icon"></div>
        Скачать
      </button> -->
      <div 
        class="project-distribution-chart__footer-show-all"
        @click="showAll = !showAll"  
      >
        Показать все
        <div :class="{ 'rotate-90': showAll }" class="project-distribution-chart__footer-show-all-icon"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { graphQueryConstructor } from "@/tools/graphQueryConstructor";
import { gQueryOptionsTemplate } from './chartHelper';
import gql from 'graphql-tag';
import { rawGet } from '@/tools/http';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "ProjectDistributionChart",
  components: {
  },
  props: {
    apolloSearchString: {
      type: String,
      default: "",
    },
    userSearchFilters: {
      type: Object,
    },
    selectedTags: {
      type: Array,
      default: () => [],
    },
  },
  apollo: {
    projectsDistribution: {
      query() {
        return gql(graphQueryConstructor(
          ...gQueryOptionsTemplate(
              this.hasUserContactsAccess,
              this.apolloSearchString,
              this.userSearchFilters,
              this.selectedTags,
              "projectsDistribution",
              this.year,
            )
        ));
      },
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
      mappedProjectsData: null,
      expandedProjects: {},
      loading: false,
      totalUsers: 0,
      showAll: false,
      chartOptionsFuncParams: {
        title: {
          word: "Участни",
          e1: "к",
          e2: "ка",
          e3: "ков",
        },
      },
    };
  },
  methods: {
    ...mapActions([
      'loadProjects2NamesByIds',
      'loadProjectsNamesByIds',
      'loadNominations2NamesByIds',
      'loadNominationsNamesByIds',
    ]),
    toggleNominations(index) {
      this.$set(this.expandedProjects, index, !this.expandedProjects[index]);
    },
    async download() {
      const query = "&filter[project][projectTypes][]=project&filter[project][projectTypes][]=contest&filter[project][projectTypes][]=contests";
      const file = await rawGet('analytics', `api/v1/widget-to-xlsx/projectMembersTempo?param[page]=projects${query}`,
        {}, {}, 'blob');
      const element = document.createElement('a');
      element.download = `Статистика по регистрациям на проекты.xlsx`;
      element.href = window.URL.createObjectURL(
        new Blob([file.data],
          { type: file.headers['content-type'] },
        ),
      );
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    yearUpdate(value) {
      this.year = value;
    },
    usersByYear(year, data) {
      let totalUsers = 0;
      data.nominations.forEach((nomination) => {
        nomination.years.forEach((nominationYear) => {
          if(year == nominationYear.year) {
            totalUsers += nominationYear.totalUsers;
          }
        });
      });

      return totalUsers ? this.prettieredQuantity(totalUsers) : '-';
    },
    nominationUsersByYear(year, data) {
      let totalUsers = 0;
      data.years.forEach((nominationYear) => {
        if(year == nominationYear.year) {
          totalUsers = nominationYear.totalUsers;
        }
      });

      return totalUsers ? this.prettieredQuantity(totalUsers) : '-';
    },
    prettieredQuantity(count) {
        return count.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, " ");
    },
  },
  computed: {
    ...mapGetters('auth', ['hasUserContactsAccess']),
    resultProjectsList() {
     if(this.mappedProjectsData) {
      return this.showAll ? this.mappedProjectsData : this.mappedProjectsData.slice(0, 9);
     } else {
      return [];
     }
    },
  },
  watch: {
    projectsDistribution: {
      async handler(data) {
        if(data) {
          this.loading = true;
          this.totalUsers = data.totalUsers;
          const projectIds = [];
          const project2Ids = [];
          const nominationIds = [];
          const nomination2Ids = [];
          let projectNames = [];
          let project2Names = [];
          let nominationNames = [];
          let nomination2Names = [];
          
          data.projects.forEach((item) => {
            if(item.projectId.length > 7) {
              project2Ids.push(item.projectId);
              item.nominations.forEach((nomination) => {
                nomination2Ids.push(nomination.nominationId);
              });
            } else {
              projectIds.push(item.projectId);
              item.nominations.forEach((nomination) => {
                nominationIds.push(nomination.nominationId);
              });
            }
          });

          project2Names = await this.loadProjects2NamesByIds(project2Ids);
          projectNames = await this.loadProjectsNamesByIds(projectIds);
          nominationNames = await this.loadNominationsNamesByIds(nominationIds);
          nomination2Names = await this.loadNominations2NamesByIds(nomination2Ids);

          data.projects.forEach((item) => {
            item.nominations.forEach((nomination) => {
              if(nomination.nominationId.length > 7) {
                nomination.name = nomination2Names[nomination.nominationId];
              } else {
                nomination.name = nominationNames[nomination.nominationId];
              }
            });
            if(item.projectId.length > 7) {
              item.name = project2Names[item.projectId];
            } else {
              item.name = projectNames[item.projectId];
            }
          });
         this.mappedProjectsData = data.projects;
        }
        this.loading = false;
      },
      immediate: true,
      deep: true,
    },
  },
}; 
</script>
<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/chart_styles';
@import '~@/styles/variables';

.project-distribution-chart {
  border-radius: rem(16);
  padding: rem(20);
  box-shadow: rem(0) rem(2) rem(16) rgba(70, 99, 171, 0.16);
  font-family: Montserrat;
  
  &__footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    &-show-all {
      display: flex;
      align-items: center;
      font-family: Montserrat;
      font-size: rem(14);
      cursor: pointer;
      font-weight: 500;
      line-height: rem(24);
      color: #4663AB;

      &-icon {
        width: rem(24);
        height: rem(24);
        background: url('~@/assets/images/user-search/show-all.svg') no-repeat center center;
      }
    }

    &-download {
      display: flex;
      padding: rem(12) rem(24);
      background: #4663AB;
      border-radius: rem(10);
      border: none;
      color: #FFFFFF;
      font-size: rem(14);
      line-height: rem(20);
      font-family: Montserrat;
      font-weight: 600;
      align-items: center;
      cursor: pointer;
      gap: rem(10);
      transition: all 0.3s ease;

      &-icon {
        width: rem(24);
        height: rem(24);
        background: url('~@/assets/images/user-search/download.svg') no-repeat center center;
      }
    }
  }
  &__title {
    font-size: rem(20);
    line-height: rem(30);
    margin: 0 0 rem(40) 0;
    font-weight: 600;
    font-family: Montserrat;
    text-transform: uppercase;
  }

  &__table {
    margin-bottom: rem(40);

    &-footer {
      display: flex;
      color: #4663AB;
      font-size: rem(14);
      font-weight: 600;
      line-height: rem(20);
      padding: rem(16) 0 rem(16) 0;
      border-bottom: rem(1) solid #E8E8E8;

      &-title {
        width: rem(236);
        text-align: right;
        padding-right: rem(36);
        margin-right: rem(8);
      }

      &-years {
        display: flex;
        width: 100%;
      }
      &-year {
        flex: 1;
      }

      &-total {
        width: rem(103);
      }
    }
    &-nomination {
      display: flex;
      margin: rem(16) 0 0 rem(10);
      border-radius: rem(15);
      background-color: #F6F9FF;

      &-title {
        width: rem(226);
        text-align: right;
        margin-right: rem(16);
        font-size: rem(14);
        font-weight: 400;
        line-height: rem(20);
        word-break: break-word;
        align-items: center;
      }

      &-years {
        display: flex;
        width: 100%;
        font-size: rem(14);
        font-weight: 400;
        line-height: rem(24);
      }

      &-year {
        align-content: center;
        flex: 1;
      }

      &-total {
        font-size: rem(14);
        font-weight: 400;
        line-height: rem(24);
        width: rem(103);
      }
    }


    &-projects {

    }

    &-project {
      display: flex;
      padding: rem(16) 0 rem(16) 0;
      border-bottom: rem(1) solid #E8E8E8;
      cursor: pointer;

      &-title {
        width: rem(236);
        position: relative;
        text-align: right;
        margin-right: rem(16);
        font-size: rem(14);
        font-weight: 600;
        line-height: rem(20);
        word-break: break-word;
        display: flex;
        justify-content: right;
        align-items: center;
      }

      &-title-icon {
        margin-left: rem(11);
        width: rem(20);
        height: rem(20);
        background: url('~@/assets/images/user-search/chevron-down.svg') no-repeat center center;
        transition: all 0.3s ease;
      }

      &-total {
        font-size: rem(14);
        font-weight: 600;
        line-height: rem(24);
        width: rem(103);
      }

      &-years {
        display: flex;
        width: 100%;
        font-size: rem(14);
        font-weight: 600;
        line-height: rem(24);
      }
      &-year {
        align-content: center;
        flex: 1;
      }
    }

    &-header {
      display: flex;
      font-size: rem(16);
      font-weight: 600;
      line-height: rem(24);
      padding-bottom: rem(16);
      border-bottom: rem(1) solid #E8E8E8;
      color: #98A0A9;
    }

    &-title {
      width: rem(236);
      text-align: right;
      padding-right: rem(36);
      margin-right: rem(8);

      &-years {
        display: flex;
        width: 100%;
      }
      &-year {
        flex: 1;
      }

      &-total {
        width: rem(103);
      }
    }
  }
}

.rotate-90 {
  transform: rotate(180deg);
  transition: all 0.3s ease;
}
</style>